import { render, staticRenderFns } from "./newsletterForm.vue?vue&type=template&id=270dafa8&"
import script from "./newsletterForm.vue?vue&type=script&lang=js&"
export * from "./newsletterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports